const language = {
  label: '언어 선택',
};

export default language;
